<template>
  <div>
    <vs-prompt
      title="Select product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-order-product-popup"
    >
      <div class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="id">Product</vs-th>
            <vs-th sort-key="isMandatoryProduct">Mandatory</vs-th>
            <vs-th sort-key="venueStockAmount">Current stock balance</vs-th>
            <vs-th sort-key="neededQuantity">Stock deficit</vs-th>
            <vs-th sort-key="caseSize">Puom size</vs-th>
            <vs-th sort-key="orderCases">Puom to order</vs-th>
            <vs-th sort-key="linePrice">Refill price</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="product-name font-medium truncate flex flex-row items-center"
                  >
                    <!-- <img width="40" :src="ProductIcon" /> -->
                    <div class="flex flex-col">
                      <div
                        class="whitespace-nowrap overflow-hidden truncate"
                        style="width: 206px"
                      >
                        {{ tr.stockProduct.name }}
                      </div>
                      <div class="text-sm text-grey">
                        {{ tr.stockProduct.number }}
                      </div>
                    </div>
                  </div>
                </vs-td>
                <vs-td :data="tr.isMandatory">
                  <vs-chip>
                    {{ tr.isMandatory | yesno }}
                  </vs-chip>
                </vs-td>
                <vs-td :data="tr.venueAmount">
                  <div class="flex">
                    <code class="whitespace-no-wrap">
                      {{ tr.venueAmount | formatDecimal(1) }}
                      <span>/</span>
                      {{ tr.venueMinimumAmount | formatDecimal(0) }}
                    </code>
                    <div class="ml-1">
                      <small
                        >{{
                          tr.currentStockLevelPercentage | formatDecimal(2)
                        }}
                        %</small
                      >
                    </div>
                  </div>
                  <div>
                    <vs-progress
                      :height="10"
                      :percent="tr.currentStockLevelPercentage"
                      :color="tr.color"
                    ></vs-progress>
                  </div>
                </vs-td>
                <vs-td :data="tr.neededPuom">
                  <vs-chip :color="tr.neededPuom > 0 ? 'primary' : ''">
                    {{ tr.neededPuom }}
                  </vs-chip>
                  <small class="ml-1">puom</small>
                  <!-- <small class="ml-1" v-if="tr.neededPuom > 0">
                    {{ tr.neededAmount }} pcs
                  </small> -->
                </vs-td>
                <vs-td :data="tr.caseSize">
                  {{ tr.stockProduct.caseSize }}
                  {{ tr.stockProduct.productUnit }}
                </vs-td>
                <vs-td :data="tr.neededPuom">
                  {{ tr.neededPuom }}
                </vs-td>
                <vs-td :data="tr.linePrice">
                  <vx-tooltip
                    v-if="tr.linePrice > 0"
                    :text="`Calculated as: ${tr.stockProduct.caseSize} pcs • ${tr.neededPuom} puom • ${tr.stockProduct.unitPrice} DKK = ${tr.linePrice} DKK`"
                  >
                    <b>{{ tr.linePrice | numberFormatDK }} DKK</b>
                    <feather-icon
                      icon="InfoIcon"
                      svgClasses="w-3 h-4"
                      class="ml-1"
                    />
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedProduct: null,

      eligibleProductsInfo: null,
    };
  },
  props: {
    existingProducts: {
      type: Array,
      default: () => [],
    },
    assignedStockProducts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.selectedProduct != null;
    },

    filteredProducts() {
      console.log("Eligible products", this.assignedStockProducts);

      if (!this.assignedStockProducts) {
        return [];
      }

      return this.assignedStockProducts
        .filter((e) => !e.isDelisted && !e.stockProduct.inactive) // Filter out delisted and inactive products
        .filter((e) => {
          // Filter out products already selected
          return !this.existingProducts.some(
            (p) => p.stockProductId === e.stockProductId
          );
        })
        .map((e) => {
          const neededAmount = Math.max(
            e.venueMinimumAmount - e.venueAmount,
            0
          );
          // Round to nearest case size
          const neededPuom = Math.max(
            Math.ceil(neededAmount / e.stockProduct.caseSize),
            0
          );

          const percentage = (e.venueAmount / e.venueMinimumAmount) * 100;

          // Calculate needed quantity
          e.currentStockLevelPercentage = percentage;
          e.color =
            percentage < 40
              ? "danger"
              : percentage < 100
              ? "warning"
              : "primary";
          e.neededAmount = Math.ceil(neededAmount);
          e.neededPuom = neededPuom;
          e.linePrice = (
            neededPuom *
            e.stockProduct.caseSize *
            e.stockProduct.unitPrice
          ).toFixed(2);
          return e;
        });
    },
  },
  methods: {
    async show() {
      // dispatch eligible products
      this.prompt = true;
    },
    async accept() {
      this.$emit("productSelected", this.selectedProduct);
    },
  },
};
</script>

<style lang="scss">
.add-order-product-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 1200px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
